<!--
追加可能なセレクトボックスを管理するモジュール
@props
  contents 表示するデータを指定する
  min 追加可能な数の下限を指定する
  appendable 追加できるのならtrue、できないのならfalseを指定する
 -->

<template>
  <append-select-list-base
    ref="base"
    #default="{ item }"
    :min="min"
    :initial="initial"
    :appendable="appendable"
  >
    <v-row>
      <v-col cols="8">
        <v-select
          v-if="isAllowEditRole(item.selected[item.index].meta)"
          class="fixed-width-500"
          outlined
          dense
          hide-details
          v-model="item.selected[item.index].name"
          :items="contents"
          return-object
          @change="onChangeSelectBox(item.index)"
        ></v-select>
        <div v-else class="mt-3 ml-3 fixed-width-250">
          {{ item.selected[item.index].name.text }}
        </div>
      </v-col>
    </v-row>
  </append-select-list-base>
</template>

<script>
import AppendSelectListBase from "./append-select-list-base.vue";

export default {
  name: "append-onr-column-select-list",
  components: {
    "append-select-list-base": AppendSelectListBase,
  },
  props: ["contents", "min", "appendable"],
  computed: {
    /**
     * 追加時の初期データ
     */
    initial() {
      if (this.contents && this.contents.length >= 1) {
        return {
          name: this.contents[0],
        };
      }
      return null;
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * エラーがあればtrueを返す
     */
    hasError() {
      return this.$refs.base.hasError();
    },
    /**
     * 編集可能であればtrueを返す
     */
    isAllowEditRole(meta) {
      if (meta && meta.type) {
        return meta.type.group_editable;
      }
      return true;
    },
    /**
     * セレクトボックスの選択が変更された
     */
    onChangeSelectBox(index) {
      this.$refs.base.onChangedSelectBox(index);
    },
    /**
     * 可変、固定で選択している全てのデータを返却する
     */
    getAllContents() {
      return this.$refs.base.getAllContents();
    },
    /**
     * セレクトボックスから選択している全ての可変データを返却する
     */
    getSelected() {
      return this.$refs.base.getSelected();
    },
    /**
     * セレクトボックスに可変データを設定する
     */
    setSelected(items) {
      console.log("setSelected items = " + JSON.stringify(items));
      this.$refs.base.setSelected(items);
    },
    /**
     * 固定値で表示している全ての固定データを返却する
     */
    getFixedContents() {
      return this.$refs.base.getFixedContents();
    },
    /**
     * 固定値で表示する固定データを設定する
     */
    setFixedContents(contents) {
      this.$refs.base.setFixedContents(contents);
    },
  },
};
</script>

<style></style>
